import { useLayoutEffect, useState } from 'react';
import { getBreakpointForWidth } from '../components/Partnerportal-Cockpit/utils/gridUtils';

const useCurrentBreakpoint = (): { currentBreakpoint: string } => {
  const [currentBreakpoint, setCurrentBreakpoint] = useState<string>(getBreakpointForWidth(window.innerWidth));

  useLayoutEffect(() => {
    function handleResize() {
      const bp = getBreakpointForWidth(window.innerWidth);
      setCurrentBreakpoint(bp);
    }
    window.addEventListener('resize', handleResize);

    handleResize();

    return () => {
      window.removeEventListener('resize', handleResize);
    };
  }, []);

  return { currentBreakpoint };
};

export default useCurrentBreakpoint;
